(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  const initializeFooter = (footer) => {
    if (footer.dataset.leobelaAccordionInitialized === 'true') return;

    footer.dataset.leobelaAccordionInitialized = 'true';

    const buttons = Array.from(
      footer.querySelectorAll('[data-leobela-footer-toggle]')
    );

    const synchronizeLayout = () => {
      buttons.forEach((button) => {
        const contentId = button.getAttribute('aria-controls');
        const content = contentId ? document.getElementById(contentId) : null;

        if (!content) return;

        if (mobileQuery.matches) {
          button.setAttribute('aria-expanded', 'false');
          content.hidden = true;
        } else {
          button.setAttribute('aria-expanded', 'true');
          content.hidden = false;
        }
      });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!mobileQuery.matches) return;

        const contentId = button.getAttribute('aria-controls');
        const content = contentId ? document.getElementById(contentId) : null;

        if (!content) return;

        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', String(!isExpanded));
        content.hidden = isExpanded;
      });
    });

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', synchronizeLayout);
    } else {
      mobileQuery.addListener(synchronizeLayout);
    }

    synchronizeLayout();
  };

  const initializeAllFooters = (root = document) => {
    root.querySelectorAll('.footer--leobela').forEach(initializeFooter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initializeAllFooters(),
      { once: true }
    );
  } else {
    initializeAllFooters();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initializeAllFooters(event.target);
  });
})();